var UtilsActions;
(function (UtilsActions) {
    UtilsActions["IS_CNPJ"] = "IsCnpj";
    UtilsActions["IS_CPF"] = "IsCpf";
    UtilsActions["IS_PIS"] = "IsPis";
    UtilsActions["IS_RG"] = "IsRg";
    UtilsActions["IS_CNH"] = "IsCnh";
    UtilsActions["GET_ADDRESS_BY_CEP"] = "getAddressByCep";
})(UtilsActions || (UtilsActions = {}));
var Actions;
(function (Actions) {
    // action types
    Actions["ADD_BODY_CLASSNAME"] = "addBodyClassName";
    Actions["REMOVE_BODY_CLASSNAME"] = "removeBodyClassName";
    Actions["ADD_BODY_ATTRIBUTE"] = "addBodyAttribute";
    Actions["REMOVE_BODY_ATTRIBUTE"] = "removeBodyAttribute";
    Actions["ADD_CLASSNAME"] = "addClassName";
    Actions["VERIFY_AUTH"] = "verifyAuth";
    Actions["GET_UNITY"] = "GetUnity";
    Actions["LOGIN"] = "login";
    Actions["LOGOUT"] = "logout";
    Actions["REGISTER"] = "register";
    Actions["UPDATE_USER"] = "updateUser";
    Actions["FORGOT_PASSWORD"] = "forgotPassword";
    Actions["SET_BREADCRUMB_ACTION"] = "setBreadcrumbAction";
    Actions["CLEAR_BREADCRUMB"] = "clearBreadcrumb";
    Actions["SET_TOTALIZERS_ACTION"] = "setTotalizerAction";
    Actions["SET_USER_ACTION"] = "setUserAction";
    Actions["CHANGE_CONTAINER_TYPE"] = "changeContainerType";
    Actions["SET_LOGIN_STEP_ACTION"] = "setLoginStepAction";
    Actions["SET_LOADING_TOGGLE"] = "setLoadingToggle";
    Actions["AUTHENTICATEUNIDADE"] = "AuthenticateUnidade";
    Actions["SET_UNABLE_LOADING"] = "SetUnableLoading";
})(Actions || (Actions = {}));
var InterceptorActions;
(function (InterceptorActions) {
    InterceptorActions["INIT"] = "init";
    InterceptorActions["DELETE_WARNING"] = "deleteWarning";
})(InterceptorActions || (InterceptorActions = {}));
var ReportActions;
(function (ReportActions) {
    ReportActions["GET_REPORT_EXCEL"] = "GetReportExcel";
    ReportActions["GET_REPORT_PDF"] = "GetReportPDF";
    ReportActions["GET_REPORT_CSV"] = "GetReportCSV";
})(ReportActions || (ReportActions = {}));
var Mutations;
(function (Mutations) {
    // mutation types
    Mutations["SET_CLASSNAME_BY_POSITION"] = "appendBreadcrumb";
    Mutations["PURGE_AUTH"] = "logOut";
    Mutations["SET_AUTH"] = "setAuth";
    Mutations["SET_USER"] = "setUser";
    Mutations["SET_PASSWORD"] = "setPassword";
    Mutations["SET_ERROR"] = "setError";
    Mutations["SET_BREADCRUMB_MUTATION"] = "setBreadcrumbMutation";
    Mutations["SET_TOTALIZER_MUTATION"] = "setTotalizerMutation";
    Mutations["SET_LAYOUT_CONFIG"] = "setLayoutConfig";
    Mutations["RESET_LAYOUT_CONFIG"] = "resetLayoutConfig";
    Mutations["OVERRIDE_LAYOUT_CONFIG"] = "overrideLayoutConfig";
    Mutations["OVERRIDE_PAGE_LAYOUT_CONFIG"] = "overridePageLayoutConfig";
    Mutations["SET_LOADING"] = "SetLoading";
    Mutations["ADD_WARNING"] = "addWarning";
    Mutations["CLEAR_WARNING"] = "clearWarning";
    Mutations["SET_CONTAINER_SIZE"] = "setCotainerSize";
    Mutations["SET_LOGIN_STEP"] = "setloginstep";
    Mutations["SET_AUTH_TOKEN"] = "setauthtoken";
    Mutations["SET_MENU"] = "SetMEnu";
    Mutations["UNABLE_LOADING"] = "UnableLoading";
})(Mutations || (Mutations = {}));
export { UtilsActions, Actions, InterceptorActions, ReportActions, Mutations, };
//# sourceMappingURL=StoreEnums.js.map